import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const CheckboxDisabledCheckedIcon = (props: SvgIconProps) => {
    const { gray300, white } = colors;

    return (
        <SvgIcon {...props}>
            <rect x="2" y="2" width="20" height="20" rx="6" fill={gray300} />

            <path
                d="M8.29661 12.445C8.06788 12.2052 7.68809 12.1963 7.44832 12.425C7.20856 12.6538 7.19962 13.0336 7.42835 13.2733L9.81007 15.7699C10.0553 16.027 10.469 16.0158 10.7 15.7459L16.4274 9.05482C16.6429 8.80308 16.6135 8.42432 16.3618 8.20883C16.11 7.99335 15.7313 8.02274 15.5158 8.27448L10.5079 14.125C10.3539 14.3049 10.0781 14.3124 9.91458 14.141L8.29661 12.445Z"
                fill={white}
            />
        </SvgIcon>
    );
};

export default CheckboxDisabledCheckedIcon;
